import type { AxiosError } from 'axios'
import type { FidelizacionApiError } from '../types'

const MENSAJES_POR_CODE: Record<string, string> = {
  config_invalid: 'La API key configurada para este reporte no es válida o fue revocada. Pide al admin que la actualice.',
  forbidden: 'No tienes permisos para acceder a este reporte.',
  ip_not_allowed: 'Tu IP no está autorizada por el laboratorio. Contacta soporte para agregarla a la allowlist.',
  not_found: 'El recurso solicitado no existe en este tenant.',
  rate_limited: 'Se alcanzó el límite de peticiones por minuto. Espera unos segundos y reintenta.',
  too_many_rows: 'El export excede 100.000 filas. Aplica filtros más restrictivos antes de descargar.',
  upstream_error: 'El API de Fidelización no respondió. Reintenta en unos segundos.',
  network_error: 'No se pudo contactar al API de Fidelización (timeout o red).',
  inactive: 'Este reporte está desactivado. Reactívalo desde Configuración.',
}

export interface FidelizacionUIError {
  title: string
  message: string
  code?: string
  requestId?: string | null
  retryAfter?: number | null
  status?: number
}

export function parseFidelizacionError(err: unknown): FidelizacionUIError {
  const ax = err as AxiosError<FidelizacionApiError>
  const status = ax?.response?.status
  const data = ax?.response?.data

  const code = data?.code
  const requestId = data?.request_id ?? null
  const retryAfter = data?.retry_after ?? null
  const upstreamMsg = data?.error

  const friendly = code && MENSAJES_POR_CODE[code]
  const title =
    status === 429 ? 'Demasiadas peticiones'
    : status === 413 ? 'Export muy grande'
    : status && status >= 500 ? 'Servicio temporalmente no disponible'
    : status === 403 ? 'Acceso denegado'
    : status === 404 ? 'No encontrado'
    : 'No se pudo completar la operación'

  return {
    title,
    message: friendly || upstreamMsg || ax?.message || 'Error desconocido',
    code,
    requestId,
    retryAfter,
    status,
  }
}
